import Link from 'next/link';

export function ButtonLink({ href, as = null, children, ...props }) {
  return (
    <Link href={href} as={as}>
      <a className="link" {...props}>
        {children}
        <style jsx>{`
          .link {
            position: relative;
            display: inline-block;
            padding: 0.625em 1.875em;
            line-height: 1;
            border-radius: 1em;
            font-size: 0.875em;
            font-weight: 600;
            text-decoration: none;
            color: var(--bgHotGreen__text);
            background-color: var(--bgHotGreen);
            box-shadow: 0 2px 32px 0 rgba(0, 12, 51, 0.15);
            user-select: none;
          }

          .link:hover,
          .link:focus {
            opacity: 0.9;
          }
        `}</style>
      </a>
    </Link>
  );
}
